export default __webpack_public_path__ + "static/media/office1-before1-480w.91914567.png";